<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill = $theme.colors.white;
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" {...$$restProps}
    ><path
        {fill}
        fill-rule="evenodd"
        d="M.2.928A.75.75 0 0 1 1.258.847L7.77 6.428 14.28.847a.75.75 0 1 1 .977 1.138l-7 6a.75.75 0 0 1-.977 0l-7-6A.75.75 0 0 1 .201.928Z"
        clip-rule="evenodd"
    /></svg
>
